import React, { useEffect, useState } from 'react';
import './TutorialsGuide.css';

const TutorialsGuide = () => {
  const [expandedBanks, setExpandedBanks] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleBank = (bankId) => {
    console.log('Toggling bank:', bankId); // Debug
    setExpandedBanks(prev => {
      const newState = {
        ...prev,
        [bankId]: !prev[bankId]
      };
      console.log('New expanded state:', newState); // Debug
      return newState;
    });
  };

  const banks = [
    {
      id: 'bb',
      name: 'Banco do Brasil',
      icon: '/icons/bancos/bancodobrasil.png',
      steps: [
        'Acesse sua conta no Internet Banking do Banco do Brasil',
        'No menu, clique em "Conta Corrente" e depois em "Extrato"',
        'Selecione a opção "Conta Corrente" ou "Extrato Mensal / Por Período"',
        'Escolha o período desejado para o extrato',
        'Clique em "Salvar" ou procure um ícone de download e selecione a opção "Money 2000+ (OFX)" ou similar',
        'O arquivo OFX será baixado em seu computador'
      ]
    },
    {
      id: 'itau',
      name: 'Itaú',
      icon: '/icons/bancos/itau.png',
      steps: [
        'Acesse sua conta no Internet Banking do Itaú',
        'Vá para "Conta Corrente"',
        'Em "Saldo e Extrato", clique em "Extrato Detalhado" ou "Consultar extrato por período"',
        'Escolha o período desejado e clique em "Continuar"',
        'Na tela do extrato, procure a opção "Salvar em outros formatos" ou similar',
        'Informe novamente o período (se solicitado) e selecione o formato "OFX / Money 2000"',
        'Clique em "Continuar" ou "Salvar" para baixar o arquivo'
      ]
    },
    {
      id: 'bradesco',
      name: 'Bradesco',
      icon: '/icons/bancos/bradesco.png',
      steps: [
        'Acesse sua conta no Internet Banking do Bradesco',
        'No menu, vá em "Saldos e Extratos"',
        'Selecione a opção "Extrato Mensal / Por Período"',
        'Defina o período desejado e clique em "Buscar"',
        'No canto superior direito da tela do extrato, clique em "Salvar como arquivo" ou em um ícone de exportação',
        'Escolha o formato "OFX (Money 2000 em diante)" ou similar',
        'O download do arquivo será iniciado'
      ]
    },
    {
      id: 'santander',
      name: 'Santander',
      icon: '/icons/bancos/santander.png',
      steps: [
        'Acesse sua conta no Internet Banking do Santander',
        'No menu, procure por "Conta Corrente" e depois "Extrato (Money)" ou similar',
        'Selecione o período desejado para o extrato e clique em "Exibir"',
        'Na tela do extrato, clique em "Exportar"',
        'Marque a opção "Money 2000 ou superior" ou "OFX"',
        'Clique em "Confirmar" para baixar o arquivo'
      ]
    },
    {
      id: 'stone',
      name: 'Stone',
      icon: '/icons/bancos/stone.png',
      steps: [
        'Acesse sua Conta Stone pelo site (conta.stone.com.br) ou pelo aplicativo',
        'No menu, vá em "Extrato"',
        'Clique em "Exportar" ou "Baixar relatório"',
        'Defina o "Tipo de exportação" como "Extrato"',
        'Selecione as datas de início e fim para o período desejado',
        'Escolha "OFX" como o "Formato do arquivo"',
        'Clique em "Baixar" para salvar o arquivo'
      ]
    },
    {
      id: 'sicredi',
      name: 'Sicredi',
      icon: '/icons/bancos/sicredi.png',
      steps: [
        'Acesse sua conta no Internet Banking do Sicredi',
        'No menu, clique em "Extrato"',
        'Escolha o período desejado e clique em "Pesquisar" ou "Consultar"',
        'Após a exibição dos lançamentos, procure e clique no botão "Gerar OFX" ou similar, geralmente localizado na parte inferior da tela',
        'O arquivo OFX será baixado em seu computador'
      ]
    }
  ];

  return (
    <div className="tutorials-page">
      {/* Navigation */}
      <nav className="tutorials-nav">
        <div className="tutorials-nav-content">
          <a href="/" className="tutorials-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </a>
          <a href="/" className="tutorials-back-btn">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            <span>Voltar ao Site</span>
          </a>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="tutorials-hero">
        <div className="tutorials-hero-content">
          <h1>Como Usar o DRE Pro</h1>
          <p>Transforme sua gestão financeira em 15 minutos</p>
          <div className="tutorials-hero-stats">
            <div className="hero-stat">
              <span className="hero-stat-number">15min</span>
              <span className="hero-stat-label">Para configurar</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">5 Passos</span>
              <span className="hero-stat-label">Simples e diretos</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">100%</span>
              <span className="hero-stat-label">Automático depois</span>
            </div>
          </div>
        </div>
      </section>

      <div className="tutorials-container">
        {/* Step Navigation */}
        <section className="step-navigation">
          <div className="step-nav-title">
            <h2>5 Passos para o Sucesso</h2>
            <p className="step-nav-subtitle">Processo simples e eficiente</p>
          </div>
          <div className="step-grid">
            <div className="step-item">
              <div className="step-circle">1</div>
              <div className="step-label">Extrair OFX</div>
            </div>
            <div className="step-item">
              <div className="step-circle">2</div>
              <div className="step-label">Upload</div>
            </div>
            <div className="step-item">
              <div className="step-circle">3</div>
              <div className="step-label">Dashboard</div>
            </div>
            <div className="step-item">
              <div className="step-circle">4</div>
              <div className="step-label">Categorizar</div>
            </div>
            <div className="step-item">
              <div className="step-circle">5</div>
              <div className="step-label">Relatórios</div>
            </div>
          </div>
        </section>

        {/* Step 1: Extract OFX */}
        <section className="tutorial-section">
          <div className="section-header">
            <div className="section-number">1</div>
            <h2 className="section-title">Extrair Arquivo OFX do Banco</h2>
            <p className="section-subtitle">Instruções detalhadas para os principais bancos brasileiros</p>
          </div>

          <div className="info-box tip">
            <h4>💡 O que é OFX?</h4>
            <p>É o formato padrão usado pelos bancos brasileiros para exportar dados. Contém todas suas transações de forma segura e estruturada.</p>
          </div>

          <div className="bank-grid">
            {banks.map((bank) => (
              <div key={bank.id} className={`bank-card collapsible ${expandedBanks[bank.id] ? 'expanded' : ''}`}>
                <div 
                  className="bank-header"
                  onClick={() => toggleBank(bank.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="bank-name">
                    <img src={bank.icon} alt={bank.name} className="bank-logo" />
                    {bank.name}
                  </div>
                  <div className="bank-toggle">
                    <svg 
                      viewBox="0 0 24 24" 
                      width="20" 
                      height="20" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                      className={`chevron ${expandedBanks[bank.id] ? 'rotated' : ''}`}
                      style={{ 
                        transform: expandedBanks[bank.id] ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </div>
                </div>
                <div 
                  className="bank-content"
                  style={{
                    maxHeight: expandedBanks[bank.id] ? '1000px' : '0px',
                    overflow: 'hidden',
                    transition: 'max-height 0.4s ease-in-out, padding 0.4s ease-in-out',
                    padding: expandedBanks[bank.id] ? '0 1.5rem 1.5rem' : '0 1.5rem'
                  }}
                >
                  <ol className="bank-steps">
                    {bank.steps.map((step, index) => (
                      <li key={index}>{step}</li>
                    ))}
                  </ol>
                </div>
              </div>
            ))}
          </div>

          <div className="info-box success">
            <h4>✅ Dica Importante</h4>
            <p><strong>Use sempre a conta PJ (pessoa jurídica)</strong> da empresa. Comece com 1 mês completo para testar o sistema.</p>
          </div>
        </section>

        {/* Steps 2-5: Process Timeline */}
        <section className="process-timeline">
          <div className="timeline-header">
            <h2 className="timeline-title">Do Upload aos Relatórios</h2>
            <p>Processo automatizado em 4 etapas</p>
          </div>
          
          <div className="timeline-steps">
            <div className="timeline-step">
              <div className="timeline-number">2</div>
              <div className="timeline-content">
                <h3>📤 Upload no Sistema</h3>
                <p>Acesse "Gerenciamento de Períodos" e faça upload do arquivo OFX. O sistema processa automaticamente e extrai:</p>
                <ul className="card-features">
                  <li>Todas as receitas do período</li>
                  <li>Todas as despesas organizadas</li>
                  <li>Resultado líquido (lucro/prejuízo)</li>
                  <li>Organização cronológica</li>
                </ul>
              </div>
            </div>

            <div className="timeline-step">
              <div className="timeline-number">3</div>
              <div className="timeline-content">
                <h3>📊 Dashboard Instantâneo</h3>
                <p>Visualização automática dos seus dados com:</p>
                <ul className="card-features">
                  <li>Receitas e despesas totais</li>
                  <li>Gráficos interativos</li>
                  <li>Comparações mensais</li>
                  <li>Indicadores de performance</li>
                </ul>
              </div>
            </div>

            <div className="timeline-step">
              <div className="timeline-number">4</div>
              <div className="timeline-content">
                <h3>🏷️ Categorização Inteligente (Opcional)</h3>
                <p>Organize fornecedores por categoria uma única vez:</p>
                <ul className="card-features">
                  <li>Associe fornecedores às categorias</li>
                  <li>IA aprende e sugere automaticamente</li>
                  <li>Funciona para sempre nas próximas importações</li>
                  <li>Tempo: ~10 minutos na primeira vez</li>
                </ul>
              </div>
            </div>

            <div className="timeline-step">
              <div className="timeline-number">5</div>
              <div className="timeline-content">
                <h3>📈 Relatórios Profissionais</h3>
                <p>Análises detalhadas para tomada de decisão:</p>
                <ul className="card-features">
                  <li>Gastos por categoria com percentuais</li>
                  <li>Comparações entre períodos</li>
                  <li>Insights automáticos da IA</li>
                  <li>Exportação em PDF</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Key Features */}
        <section className="tutorial-section">
          <div className="section-header">
            <h2 className="section-title">Principais Funcionalidades</h2>
            <p className="section-subtitle">Tudo que você precisa para uma gestão financeira profissional</p>
          </div>

          <div className="cards-grid">
            <div className="feature-card">
              <div className="card-icon">🤖</div>
              <h3 className="card-title">IA que Aprende</h3>
              <p className="card-description">
                Sistema inteligente que aprende com suas categorizações e automaticamente 
                sugere classificações para novos fornecedores.
              </p>
              <ul className="card-features">
                <li>Sugestões automáticas</li>
                <li>Melhora com o uso</li>
                <li>Economia de tempo</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="card-icon">📊</div>
              <h3 className="card-title">Relatórios Instantâneos</h3>
              <p className="card-description">
                Relatórios profissionais gerados automaticamente com análises 
                comparativas e insights acionáveis.
              </p>
              <ul className="card-features">
                <li>DRE automático</li>
                <li>Comparações mensais</li>
                <li>Gráficos interativos</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="card-icon">🔒</div>
              <h3 className="card-title">Segurança Total</h3>
              <p className="card-description">
                Seus dados financeiros protegidos com criptografia bancária 
                e nunca compartilhados com terceiros.
              </p>
              <ul className="card-features">
                <li>Criptografia AES-256</li>
                <li>Backup automático</li>
                <li>Conformidade LGPD</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="card-icon">📱</div>
              <h3 className="card-title">Acesso Universal</h3>
              <p className="card-description">
                Funciona perfeitamente em computador, tablet e celular 
                com sincronização automática entre dispositivos.
              </p>
              <ul className="card-features">
                <li>Multiplataforma</li>
                <li>Sincronização automática</li>
                <li>Interface responsiva</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="card-icon">⚡</div>
              <h3 className="card-title">Performance Superior</h3>
              <p className="card-description">
                Processamento instantâneo de arquivos grandes e geração 
                de relatórios em segundos, não minutos.
              </p>
              <ul className="card-features">
                <li>Processamento instantâneo</li>
                <li>Interface rápida</li>
                <li>Otimização automática</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="card-icon">🤝</div>
              <h3 className="card-title">Suporte Especializado</h3>
              <p className="card-description">
                Equipe especializada disponível via WhatsApp para ajudar 
                na configuração e tirar todas suas dúvidas.
              </p>
              <ul className="card-features">
                <li>Suporte via WhatsApp</li>
                <li>Resposta rápida</li>
                <li>Treinamento personalizado</li>
              </ul>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="faq-section">
          <div className="faq-header">
            <h2 className="faq-title">Perguntas Frequentes</h2>
            <p>Respostas diretas para as dúvidas mais comuns</p>
          </div>
          
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-question">
                <span>Posso importar dados de múltiplos bancos?</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                Sim! Você pode importar arquivos OFX de diferentes bancos. O sistema consolidará 
                automaticamente todos os dados em uma visão única e organizada.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span>E se eu errar na categorização?</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                Sem problemas! Você pode alterar categorizações a qualquer momento. As mudanças 
                se aplicam automaticamente a todas as transações do mesmo fornecedor.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span>Quanto tempo demora o processamento?</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                O processamento é instantâneo! Arquivos de até 12 meses são processados em segundos. 
                Mesmo arquivos muito grandes raramente demoram mais que alguns minutos.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span>Posso usar dados históricos?</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                Sim! Você pode importar dados históricos de até 2 anos para análises comparativas 
                mais robustas e tendências precisas.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span>É obrigatório categorizar tudo?</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                Não! Mesmo sem categorização você já obtém insights valiosos. A categorização 
                potencializa as análises, mas pode ser feita gradualmente.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <span>Como compartilhar com meu contador?</span>
                <span>+</span>
              </div>
              <div className="faq-answer">
                Você pode exportar relatórios em PDF e compartilhar 
                diretamente com seu contador via email ou link seguro.
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="cta-section">
          <div className="cta-content">
            <h2 className="cta-title">Pronto para Começar?</h2>
            <p className="cta-subtitle">
              Transforme sua gestão financeira agora mesmo com o DRE Pro
            </p>
            <div className="cta-buttons">
              <a href="/#pricing" className="cta-btn primary">
                <span>Ver Planos</span>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
              <a 
                href="https://wa.me/554137984531" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cta-btn secondary"
              >
                <span>Falar no WhatsApp</span>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
              </a>
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <footer className="tutorials-footer">
        <div className="footer-content">
          <a href="/" className="footer-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </a>
          <p className="footer-text">
            © {new Date().getFullYear()} DRE Pro. Gestão financeira inteligente.
          </p>
          <a href="/" className="footer-back">
            Voltar ao Site Principal
          </a>
        </div>
      </footer>
    </div>
  );
};

export default TutorialsGuide;